import * as React from 'react';
import { useEffect, useState } from 'react';
import FindBarbersSection from './components/FindBarbersSection';
import PartnerCarousel from './components/PartnerCarousel';
import MarketingSection from './components/MarketingSection';
import { companyName } from '../defaults/AppDefaults';
import StickyFooter from '../pages/components/StickyFooter';
import { LandingPartner } from '../types/partner';
import { getNewPartners } from '../middleware/registration_service/getRequests';
import { getRecommendedPartners } from '../middleware/reservation_service/getRequests';
import {
  getNewToBarbersLimitedData,
  getRecommendedPartnersData,
} from '../utils/landingPartnerUtils';

export default function Home() {
  const [newPartners, setNewPartners] = useState<LandingPartner[]>([]);
  const [recommendedPartners, setRecommendedPartners] = useState<
    LandingPartner[]
  >([]);

  useEffect(() => {
    let isMounted = true;

    const loadNewPartners = async () => {
      try {
        const response = await getNewPartners();
        const partners = await getNewToBarbersLimitedData(response.data);
        if (isMounted) {
          setNewPartners(partners);
        }
      } catch (err) {
        console.error('Failed to load new partners:', err);
      }
    };

    const loadRecommendedPartners = async () => {
      try {
        const response = await getRecommendedPartners();
        const partners = await getRecommendedPartnersData(response.data);
        if (isMounted) {
          setRecommendedPartners(partners);
        }
      } catch (err) {
        console.error('Failed to load recommended partners:', err);
      }
    };

    loadNewPartners();
    loadRecommendedPartners();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div style={{ backgroundColor: '#0f1013' }}>
      <FindBarbersSection />
      <PartnerCarousel
        title="Recommended For You"
        subtitle="Popular shops and barbers booked by customers like you"
        partners={recommendedPartners}
        bgcolor="#0f1013"
      />
      <PartnerCarousel
        title="New to Barbers Limited"
        subtitle="Recently joined shops and independent barbers"
        partners={newPartners}
        bgcolor="#16171c"
      />
      <MarketingSection />
      <StickyFooter {...companyName} />
    </div>
  );
}
